import { useSearchParams as useSearchParamRouter } from 'react-router';

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParamRouter();

  function removeSearchParams(resource = '') {
    if (searchParams.get(resource)) {
      searchParams.delete(resource);
      setSearchParams(searchParams, { replace: true });
    }
  }

  function addSearchParams(key: string, value = '') {
    searchParams.set(key, value);
    setSearchParams(searchParams, { replace: true });
  }

  function getAllSearchParams(): Record<string, string> {
    const paramsObj = Array.from(searchParams.keys()).reduce(
      (acc, val) => ({ ...acc, [val]: searchParams.get(val) }),
      {}
    );

    return paramsObj;
  }

  return {
    searchParams,
    addSearchParams,
    removeSearchParams,
    getAllSearchParams,
  };
};

function getCurrentSearchParam() {
  return new URLSearchParams(window.location.search);
}

export function generatePathWithSearch({
  pathname = window.location.pathname,
  appendSearch = [],
  hash,
}: {
  pathname?: string;
  appendSearch?: [string, string][];
  hash?: string;
}) {
  const searchParams = getCurrentSearchParam();

  appendSearch.forEach(([key, value]) => {
    searchParams.set(key, value);
  });

  return {
    pathname,
    search: searchParams.toString(),
    ...(hash ? { hash: hash.startsWith('#') ? hash : `#${hash}` } : {}),
  };
}

export function isValidExternalURL(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}
